import { CxEvent } from '@spartacus/core';

export class Ga4GgProductWhereToBuyPartnerEvent extends CxEvent {
  event?: string;
  name?: string;
  currency?: string;
  value?: number;
  visitor_type?: string;
  items?: {
    item_id?: string;
    item_name?: string;
    price?: number;
  }[];
}
